module.exports = __webpack_public_path__ + "images/line_friend_lp/campaign-leading_8cb16ec06a291134b34442295ce96d95.png";